import { useQuery } from "react-query";

import { RQ_KEY } from "../../constants/query";
import { getClub } from "../../services/clubs";
import { TClubSimple } from "../schemas/club";

export default function useQueryClubId(id: string) {
  return useQuery<TClubSimple, Error>([RQ_KEY.CLUB], () => getClub(id));
}
